/** Display-only clock format; keep shared accounting/duration formatters unchanged. */
export function formatTimerClock(seconds: number): string {
  const value = Math.max(0, Math.floor(seconds));
  const hours = Math.floor(value / 3600);
  const minutes = hours ? Math.floor((value % 3600) / 60) : Math.floor(value / 60);
  const tail = `${String(minutes).padStart(2, '0')}:${String(value % 60).padStart(2, '0')}`;
  return hours ? `${hours}:${tail}` : tail;
}

/** Measure by digit count, rather than refitting every second. */
export function timerClockSample(seconds: number): string {
  return formatTimerClock(seconds).replace(/\d/g, '8');
}
